import { EventType } from '@anduin/shared';
import {
  PAYMENT_HISTORY_STEP_TO_EVENT_TYPE,
  PAYMENT_HISTORY_STEP_TO_WORKFLOW,
  PaymentHistoryWorkflowStepMetaDataMap,
  PaymentsHistoryStep,
} from './payment-history-workflow.models';
import {
  PAYMENT_PLANS_STEP_TO_EVENT_TYPE,
  PAYMENT_PLANS_STEP_TO_WORKFLOW,
  PaymentPlansWorkflowStepMetaDataMap,
  PaymentsPlansStep,
} from './payment-plans-workflow.models';

/**
 * Workflow taxonomy owned by the payments module. Each value is the `workflow` string
 * emitted on tracking events for funnel grouping in downstream analytics.
 */
export enum PaymentsWorkflowType {
  HISTORY = 'PAYMENT_HISTORY',
  PLANS = 'PAYMENT_PLANS',
}

/** Union of every step enum value owned by the payments module. */
export type PaymentsWorkflowStep = PaymentsHistoryStep | PaymentsPlansStep;

/**
 * Combined metadata map across every payments workflow. Indexing by a literal step yields
 * exactly that step's metadata shape.
 */
export type PaymentsWorkflowStepMetaDataMap = PaymentHistoryWorkflowStepMetaDataMap & PaymentPlansWorkflowStepMetaDataMap;

/** Runtime lookup: `step → workflow`. */
export const PAYMENTS_STEP_TO_WORKFLOW: Record<PaymentsWorkflowStep, string> = {
  ...PAYMENT_HISTORY_STEP_TO_WORKFLOW,
  ...PAYMENT_PLANS_STEP_TO_WORKFLOW,
};

/** Runtime lookup: `step → EventType` (USER / SYSTEM / ERROR), unioned across every workflow. */
export const PAYMENTS_STEP_TO_EVENT_TYPE: Record<PaymentsWorkflowStep, EventType> = {
  ...PAYMENT_HISTORY_STEP_TO_EVENT_TYPE,
  ...PAYMENT_PLANS_STEP_TO_EVENT_TYPE,
};
